import { get_reports } from '../api/report';

export const getReports = (reportParams) =>
    new Promise(function (resolve, reject) {
        get_reports(reportParams)
            .then(data => resolve(data))
            .catch(error => reject(error));
    });